import { createSelector } from 'reselect'
import { getPageParams, getPageData } from 'selectors/page'
export { getPageParams, getPageData }
import { Curator } from '../types'
export const getCurationStatus = createSelector(
  [getPageData],
  (pageData): number => pageData.curationStatus || 0
)
export const getManageArtworkOpen = createSelector(
  [getPageData],
  (pageData): boolean => pageData.manageArtworkOpen || false
)
export const getIsVisiiAvailable = createSelector(
  [getPageData],
  (pageData): boolean => pageData.visiiExist || false
)
export const getVisiiMetadata = createSelector(
  [getPageData],
  (pageData): Record<string, any> | null | undefined => pageData.visiiMetadata
)

//art edit promo related selectors
export const getPromo = createSelector(
  [getPageData],
  (pageData): Record<string, any> => pageData.promo || {}
)

export const getPromoCode = createSelector([getPromo], (promo): string => promo.promoCode || '')

export const getPromoDiscount = createSelector([getPromo], (promo): number => promo.discount || 0)

export const getPromoHash = createSelector([getPromo], (promo): string => promo.hash || '')

//aa section related selectors
export const getCurator = createSelector([getPageData], (pageData): Curator => pageData.curator)
